export enum MediaQueries {
  BIG_MOBILE = '(max-width: 1200px)',
  NORMAL_MOBILE = '(max-width: 744px)',
  TABLET = '(min-width: 745px) and (max-width: 1200px)',
  DESKTOP = '(min-width: 1200px)',
  TOUCHABLE = '(pointer: coarse)'
}